import React from 'react'

export default function Spinner({ size = 16, thickness = 2, className = '' }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={`animate-spin rounded-full border-primary border-b-2 ${className}`}
      style={{ width: size, height: size, borderBottomWidth: thickness }}
    />
  )
}